// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__ZZcE+","transparent":"Modal_transparent__sh789"};